import { Component } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PersistStorageKeys, PersistStorageService } from '../../services/persist-storage.service';
import { environment } from '../../environments/environment';
import { AppState } from '../../store';
import { Store } from '@ngrx/store';
import * as fromConfig from '../../store/config/config.reducer';
import { Router } from '@angular/router';
import { AuthTokenDecoded, AuthTokenPayload, AuthTokenResponse } from '../../model/auth-token';
import { first } from 'rxjs';
import decodeToken from '../../utils/decodeToken';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
})
export class AuthenticationComponent {
  isDev = !environment.production;

  formGroup = new FormGroup({
    grantType: new FormControl<'client_credentials'>('client_credentials'),
    clientId: new FormControl<string>('28d5bae2-67c1-4327-9ca8-23a481f78300'),
    clientSecret: new FormControl<string>('RiffeRuiz1'),
  });

  formGroupSessionAuth = new FormGroup({
    sessionAuth: new FormControl<string | null>(null, Validators.required),
  });

  constructor(
    private store: Store<AppState>,
    private apiService: ApiService,
    private persistStorage: PersistStorageService,
    private router: Router,
  ) {}

  handleSave(): void {
    const { grantType, clientId, clientSecret } = this.formGroup.value;

    if (!grantType) {
      this.persistStorage.removeItem(PersistStorageKeys.SessionTokenGrantType);
    } else {
      this.persistStorage.setString(PersistStorageKeys.SessionTokenGrantType, grantType);
    }

    if (!clientId) {
      this.persistStorage.removeItem(PersistStorageKeys.SessionTokenClientId);
    } else {
      this.persistStorage.setString(PersistStorageKeys.SessionTokenClientId, clientId);
    }

    if (!clientSecret) {
      this.persistStorage.removeItem(PersistStorageKeys.SessionTokenClientSecret);
    } else {
      this.persistStorage.setString(PersistStorageKeys.SessionTokenClientSecret, clientSecret);
    }

    this.fetchNewToken(grantType, clientId, clientSecret);
  }

  authBySession() {
    if (this.formGroupSessionAuth.valid && this.formGroupSessionAuth.value.sessionAuth) {
      this.apiService.setSessionId(this.formGroupSessionAuth.value.sessionAuth);
      this.retry();
    }
  }

  private fetchNewToken(
    grantType: string | null | undefined,
    clientId: string | null | undefined,
    clientSecret: string | null | undefined,
  ): void {
    if (!grantType || !clientId || !clientSecret) {
      alert('Please fill out all fields.');

      return;
    }

    const payload: AuthTokenPayload = {
      grant_type: grantType,
      client_id: clientId,
      client_secret: clientSecret,
    };

    void this.apiService
      .postAuthToken(payload)
      .pipe(first())
      .subscribe((response: AuthTokenResponse) => {
        const decodedToken = decodeToken(response.access_token) as AuthTokenDecoded;

        this.persistStorage.setString(PersistStorageKeys.SessionToken, response.access_token, 'session');
        this.persistStorage.setString(PersistStorageKeys.AgentCategory, String(decodedToken.agent_category), 'session');
        this.persistStorage.setString(PersistStorageKeys.GivenName, String(decodedToken.given_name), 'session');
        this.persistStorage.setString(PersistStorageKeys.FamilyName, String(decodedToken.family_name), 'session');
        this.persistStorage.setString(PersistStorageKeys.AgentMail, String(decodedToken.agent_email), 'session');
        if (decodedToken.agent_phone) {
          this.persistStorage.setString(PersistStorageKeys.AgentPhone, String(decodedToken.agent_phone), 'session');
        }
        const storedAgentNumber = String(decodedToken.az_agent_number) === 'undefined' ? undefined : String(decodedToken.az_agent_number);
        if (storedAgentNumber) {
          this.persistStorage.setString(PersistStorageKeys.AgentNumber, storedAgentNumber, 'session');
        }

        this.retry();
      });
  }

  private retry(): void {
    this.store.dispatch(fromConfig.actions.fetchStart());
    void this.router.navigate(['page', 'step1']);
  }
}
